/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/023-pacman': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.074 2.794a8 8 0 100 10.412L10 8l5.074-5.206zM11 1.884a1.116 1.116 0 110 2.232 1.116 1.116 0 010-2.232z"/>'
  }
})
